import moment from 'moment';

class ComplementoVehiculoUsadoRequestInputTransformer {
  getName() {
    return 'VehiculoUsado';
  }

  make(input) {
    const { Complemento } = input;

    if (!Complemento || !Complemento.VehiculoUsado) {
      return input;
    }

    const { VehiculoUsado } = Complemento;

    let { InformacionAduanera = [] } = VehiculoUsado;

    input.Complemento = {
      ...Complemento,
      VehiculoUsado: {
        ...VehiculoUsado,
        Version: '1.0',
        InformacionAduanera: InformacionAduanera.map((item) => {
          return {
            ...item,
            fecha: moment(item.fecha).format('YYYY-MM-DD'),
          };
        }),
      },
    };

    return input;
  }
}

export default ComplementoVehiculoUsadoRequestInputTransformer;
